import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HubspotAuthService } from '../../../modules/cac/services/hubspot-auth.service';
import { AuthService } from '../../service/auth.service';
import { RegisterComponent } from '../register/register.component';
import { ErrorMessageService } from '../../services/error-message.service';

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, RegisterComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  form = {
    username: '',
    password: ''
  };   

  error = '';
  showRegisterModal = false;
  showPassword = false;

  constructor(
    private authService: AuthService, 
    private router: Router, 
    private hubspotService: HubspotAuthService,
    private errorMessageService: ErrorMessageService
  ) {}

  goToHome(): void {
    this.router.navigate(['/']);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    // Réinitialiser l'erreur
    this.error = '';
    
    this.authService.login({
      username: this.form.username,
      password: this.form.password
    }).subscribe({
      next: (res) => {
        const token = res?.access_token;
        if (token) {
          localStorage.setItem('access_token', token);
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            if (payload.user_id) {
              localStorage.setItem('user_id', payload.user_id.toString());
            }
          } catch (e) {
            console.error('Failed to parse JWT token', e);
          }
        }
        
        const userObj = res?.user || res;
        const email = userObj?.email;
        const role = userObj?.role;
        
        if (role) localStorage.setItem('role', role);
        if (email) {
          localStorage.setItem('username', email);
          localStorage.setItem('email', email);
        }
        this.router.navigate(['/select-module']);
      },
      error: (err) => {
        console.error('Erreur login:', err);

        // Gérer les erreurs de parsing JSON (serveur renvoie HTML)
        if (err.message && err.message.includes('Unexpected token')) {
          this.error = 'Le serveur est temporairement indisponible. Veuillez réessayer dans quelques instants.';
          return;
        }

        // Extraire le message d'erreur sans code HTTP
        if (err?.error?.detail) {
          this.error = err.error.detail;
        } else if (typeof err?.error === 'string') {
          // Vérifier si c'est du HTML
          if (err.error.includes('<!DOCTYPE') || err.error.includes('<html')) {
            this.error = 'Le serveur est temporairement indisponible. Veuillez réessayer dans quelques instants.';
          } else {
            this.error = err.error;
          }
        } else {
          const { detail } = this.errorMessageService.getErrorMessage(err);
          this.error = detail || 'Une erreur est survenue lors de la connexion. Veuillez réessayer.';
        }
      }
    });
  }

  loginWithHubSpot() {
    this.hubspotService.loginWithHubspot(this.form.username, this.form.password).subscribe({
      next: (res) => {
        window.location.href = res.auth_url;
      },
      error: (err) => {
        this.error = 'Identifiants incorrects. Veuillez vérifier votre email et mot de passe.';
      }
    });
  }

  openRegisterModal() {
    this.showRegisterModal = true;
  }

  onRegisterSuccess() {
    this.showRegisterModal = false;
    // Optionnel : afficher un message de succès
  }
}
